function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "map-pin");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "map-pin__marker",
  fill: "#d7135b",
  d: "M14.5 0A14.48 14.48 0 0 0 0 14.47C0 24.55 14.5 41 14.5 41S29 24.55 29 14.47A14.48 14.48 0 0 0 14.5 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "map-pin__circle",
  fill: "#fff",
  fillRule: "evenodd",
  d: "M14.5 10a4.5 4.5 0 1 1-4.5 4.5 4.49 4.49 0 0 1 4.5-4.5z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "map-pin",
    width: 29,
    height: 41,
    viewBox: "0 0 29 41"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/pin.676e375e.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/svgs/pin.svg
// module id = 773
// module chunks = 0